var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.833 10.52V8.567c0-.749.58-1.337 1.44-1.673a4.948 4.948 0 00-1.731-.31c-1.103 0-2.121.36-2.944.968a4.677 4.677 0 003.235 2.968zm5.18-2.136c-.23-.311-.997-.634-1.971-.634-1.17 0-2.042.465-2.042.817v2.1a4.664 4.664 0 004.013-2.283zM4.571 5.708a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625zm3.47.584a1.167 1.167 0 100-2.334 1.167 1.167 0 000 2.334zM6 11.833A5.833 5.833 0 116 .167a5.833 5.833 0 010 11.666z"
  })));
}
export default SvgFriends;